
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

/*
  Generated class for the SocketProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SocketProvider {
  url= 'wss://snaplibs-ws-spring-boot.herokuapp.com/';
  socket;
  dataSubject = new Subject();
  name;
  roomNumber;
  players;
  screenWidth;
  scaler = 1;
  isHost = false;

  constructor() {
    console.log('Hello SocketProvider Provider');
    this.connect();
  }

  setName (name) {
    this.name = name;
  }

  setScaler (width) {
    if ((width - 72) < 500) {
      this.scaler = (width - 72) / 500;
    }
  }

  setRoomNumber (number) {
    this.roomNumber = number;
  }

  setPlayers (players) {
    this.players = players;
  }

  getStateSubject () {
    return this.dataSubject;
  }

  connect() {
    this.socket = new WebSocket(`${this.url}/game`);
    this.socket.onmessage = this.handleMessage.bind(this);
  }

  disconnect() {
    if (this.socket !== null) {
      this.socket .close();
    }
    console.log("Disconnected");
  }

  handleMessage (data) {
    console.log('received: ', data);
    this.dataSubject.next(JSON.parse(data.data));
  }

  sendMessage (message) {
    console.log('message sent: ', message);
    this.socket.send(JSON.stringify(message));
  }

  getRandomBackground () {
    const index = Math.round(Math.random() * 7);
    return ['001.png','002.png','003.png','004.png','005.png','006.png','007.png'][index];
  }

}



// WEBPACK FOOTER //
// ./src/providers/socket/socket.ts